module.exports = __webpack_public_path__ + "img/rotate-ccw.7260812b.svg";